import React, { useState, useEffect } from 'react';
import { socket } from './socket';
import { ConnectionState } from './components/ConnectionState';
import { MyForm } from './components/MyForm';
import { Slideshow } from './components/Slideshow';
import { ConnectForm } from './components/ConnectForm';
import { TextInputWithPopup } from './components/InputField';
import { StartButtonWithPopup } from './components/StartButton';
import { SkipButton } from './components/SkipButton';
import AppContainer from './components/ContainerComponent';
import { message } from 'antd';

export default function App() {
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [username, setUsername] = useState(''); // Új állapot a felhasználónév tárolásához
  const [roomname, setRoomname] = useState(''); // Új állapot a szobanév tárolásához
  const [dynamicHeading, setDynamicHeading] = useState("Join a game");
  const [imageUrls, setImageUrls] = useState([]);
  const [showButton, setShowButton] = useState(false); // Állapot a gomb megjelenítéséhez
  const [started, setStarted] = useState(false); // Add this line to track whether the game is started or not
  const [imageUrl, setImageUrl] = useState(''); // Új állapot az URL tárolására
  const [voteType, setVoteType] = useState('none'); // Új állapot a felhasználónév tárolásához


  //ph
  const [activeComponent, setActiveComponent] = useState("no");
  const handleComponentChange = (component) => {
    setActiveComponent(component);
  };


  const startGameEvent = () => {
    if (isConnected) {
      socket.emit('toMaster', { type: 'gameStart', data: {from: localStorage.getItem('userID'), startedBy: localStorage.getItem('username')}}); 
    }
  };

  const skipEvent = () => {
    if (isConnected) {
      socket.emit('toMaster', { type: 'skip', data: {from: localStorage.getItem('userID'), startedBy: localStorage.getItem('username')}}); 
    }
  };

  const voteEvent = (votei) => {
    if (isConnected) {
      socket.emit('toMaster', { type: 'voteEvent', data: {from: localStorage.getItem('userID'), myVote: votei, voteType: voteType}}); 
    }
  };

  const submitEvent = (text) => {
    if (isConnected) {
      socket.emit('toMaster', { type: 'submitText', data: {from: localStorage.getItem('userID'), myStory: text}}); 
    }
  };


  const fetchAndSetImageUrls = () => {
    fetch("http://localhost:3000/static/getimages/5")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const imageUrls = data.Images.map((imageObject) => {
          const key = imageObject.Key;
          return `https://tixid.fra1.cdn.digitaloceanspaces.com/${key}`;
        });
        setImageUrls(imageUrls);
      })
      .catch(error => {
        console.error("Hiba a képek lekérésekor:", error);
      });
  };
  const clearImages = () => {
      setImageUrls([]);
  };
  
  



  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      setDynamicHeading("Waiting for the game controller!");
      clearImages();
      handleComponentChange('');
    }

    
    function OnEvent(value) {
      switch (value[0].type) {
        case "idle":
          setDynamicHeading(value[0].data.title);
          handleComponentChange('');
          break;
        case "onboarding":
          setDynamicHeading(value[0].data.title);
          handleComponentChange('Onboarding');
          break;
        case "startGame":
          setDynamicHeading(value[0].data.title);
          setStarted(value[0].data.started);
          handleComponentChange('');
          break;
        case "cardAction":
          let imageUrls = [];
            setDynamicHeading(value[0].data.title);
            handleComponentChange('Slideshow');
            setVoteType(value[0].data.voteType)
            setShowButton(value[0].data.enabbleButton);
            imageUrls = value[0].data.cards;
            /*if (value[0].data.cards && value[0].data.cards.length > 0) {
              for (const card of value[0].data.cards) {
                if (card && card.URL) {
                  imageUrls.push(card.URL);
                }
              }
            }*/
            console.log(imageUrls);
            setImageUrls(imageUrls);
          break;
        case "titleRequest":
            setDynamicHeading(value[0].data.title);
            setImageUrl(value[0].data.chosedCard);
            handleComponentChange('TextInputWithPopup');
          break;
        default:
          console.log("NINCS ILYEN EVENT!")
          break;
      }
    }

    function onDisconnect() {
      setIsConnected(false);
      setDynamicHeading("We lost the connection!");
    }

    function onGreating(value) {
        console.log(value)
        socket.emit("acceptConnection", true);

        // Assuming `value` contains the `started` information
        const gameStarted = value[0].started;

        // Update the `started` state based on the received value
        setStarted(gameStarted);
    }

    function onSession(value){
      if (value && value.userID) {
        localStorage.setItem('userID', value.userID);
      }
    }

    socket.on('connect', onConnect);
    socket.on('sendAll', OnEvent);
    socket.on('sendOnlySelected', OnEvent);
    socket.on('disconnect', onDisconnect);
    socket.on('greating', onGreating);
    socket.on('session', onSession);
    socket.on("connect_error", (err) => {
      message.error('Error: ' + err.message);
      console.log(err)
      
    });

    return () => {
      socket.off('connect', onConnect);
      socket.off('sendAll', OnEvent);
      socket.off('sendOnlySelected', OnEvent);
      socket.off('disconnect', onDisconnect);
      socket.off('greating', onGreating);
      socket.off('session', onSession)
      socket.off("connect_error", (err) => {
        message.error('Error: ' + err.message);
        console.log(err)
        
      });
    };
  }, []);

  return (
    <div className="App">
      <AppContainer heading={dynamicHeading}>
      {isConnected && activeComponent === 'TextInputWithPopup' && (
      <TextInputWithPopup 
      imageUrl={imageUrl}
      submitEvent={submitEvent}
      />
        )}

        {isConnected && activeComponent === 'Slideshow' && (
          <Slideshow 
          imagesData={imageUrls}
          showButton={showButton}
          voteEvent={voteEvent} />
        )}
      {isConnected && !started && <StartButtonWithPopup startGameEvent={startGameEvent} />}
      {isConnected && activeComponent === 'Onboarding' && <SkipButton skipEvent={skipEvent} />}
      {isConnected ? null : (
          <ConnectForm
            setUsername={setUsername}
            setRoomname={setRoomname}
          />
        )}
        <ConnectionState isConnected={ isConnected } />



      </AppContainer>
    </div>
  );
}